import { Component, inject, input, OnInit, signal } from '@angular/core';
import { PackageCardComponent } from '../../../offer-list/components/package-card/package-card.component';
import { CategoryHaloPackage, HaloPackageData } from '@data/domain/package.entity';
import { GetCategoryHaloPackageUsecase } from '@usecase/package/get-category-halo-package/get-category-halo-package.usecase';
import { GetCategoryHaloPackageResp } from '@usecase/package/get-category-halo-package/get-category-halo-package.type';
import { GetHaloPackageUsecase } from '@usecase/package/get-halo-package/get-halo-package.usecase';
import { GetHaloPackageDto, GetHaloPackageResp } from '@usecase/package/get-halo-package/get-halo-package.type';
import { PackageCard } from '../../../offer-list/components/package-card/package-card';
import { DialogService } from '@shared/component.dialog';
import { PromoDetailComponent } from '@presentation/landing/component/promo-detail/promo-detail.component';
import { PromoDetailData } from '@presentation/landing/component/promo-detail/promo-detail';
import { ITEM, MSISDN } from '@utils/constants';

@Component({
  selector: 'app-packages-option',
  standalone: true,
  imports: [PackageCardComponent],
  templateUrl: './packages-option.component.html',
  styleUrl: './packages-option.component.scss'
})
export class PackagesOptionComponent implements OnInit {
  msisdn = input<number>();

  haloPackageData = signal<HaloPackageData[]>([]);
  categoryHaloPackageData = signal<CategoryHaloPackage[]>([]);
  categoryActive = signal<string | undefined>(undefined);

  private readonly dialogService = inject(DialogService);
  private readonly getCategoryHaloPackageUsecase = inject(GetCategoryHaloPackageUsecase);
  private readonly getHaloPackageUsecase = inject(GetHaloPackageUsecase);

  ngOnInit(): void {
    this.getCategoryHaloPackage();
  }
  getCategoryHaloPackage() {
    this.getCategoryHaloPackageUsecase.execute().subscribe({
      next: (res: GetCategoryHaloPackageResp) => {
        this.categoryHaloPackageData.set(res.data.category);
        this.handleDefaultData(res.data.category[ITEM.START_INDEX].menu_level);
      }
    });   
  }

  handleDefaultData(menuLevel: string) {
    this.getHaloPackage(menuLevel);
    this.categoryActive.set(menuLevel);
  }

  getHaloPackage(menuLevel: string) {
    this.categoryActive.set(menuLevel);
    const payload: GetHaloPackageDto = {
      msisdn: this.msisdn() ?? MSISDN.EMPTY_MSISDN,
      menu: menuLevel
    };

    this.getHaloPackageUsecase.execute(payload).subscribe({
      next: (res: GetHaloPackageResp) => {
        this.haloPackageData.set(res.data.List);
      }
    });
  }

  handlePackageCardData(event: HaloPackageData) {
    return {
      name: event.Name,
      price: event.Price,
      validity: event.Validity
    } as PackageCard;
  }

  onCickPackage(event: HaloPackageData) {
    const DIALOG_DATA:PromoDetailData = {
      id: event.ID,
      originalprice: event.OriginalPrice,
      price: event.Price,
      validity: event.Validity,
      longdesc: event.Longdesc,
      terms: event.Terms,
      name: event.Name,
      trxpackage: event.TrxPackage,
      quota: event.Quota,
      isAffiliatePackage: false
    };
    this.dialogService.open(PromoDetailComponent, {
      data: DIALOG_DATA
    });
  }
}
